import React from 'react';

function ShowDetail() {
  return (
    <div className="loader center">
      <i className="fas fa-cog fa-spin" />
    </div>
  );
}

export default ShowDetail;